import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {CollectionSearchParamsModel} from "../models/collection-search-params.model";
import {CollectionSearchParamsFactoryService} from "../services/factories/collection-search-params-factory.service";
import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";

export class CollectionSearchForm extends ObservableBaseForm<CollectionSearchParamsModel> {
    public get collection(): AbstractControl {
        return this.formInstance.get("collection");
    }

    public get sorting(): AbstractControl {
        return this.formInstance.get("sorting");
    }

    public get pageNumber(): AbstractControl {
        return this.formInstance.get("pageNumber");
    }

    public get filter(): AbstractControl {
        return this.formInstance.get("filter");
    }

    public static createForm(
        formBuilder: FormBuilder, initialValues: CollectionSearchParamsModel,
        searchParamsFactoryService: CollectionSearchParamsFactoryService
    ): CollectionSearchForm {

        const form = formBuilder.group({
            collection: [initialValues.collection],
            sorting: [initialValues.sorting],
            pageNumber: [initialValues.pageNumber],
            filter: [initialValues.filter]
        });

        return new CollectionSearchForm(form, initialValues, searchParamsFactoryService);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: CollectionSearchParamsModel,
        private searchParamsFactoryService: CollectionSearchParamsFactoryService
    ) {
        super(formInstance, initialValues);
        merge(
            this.changeObservable,
            this.submitObservable
        )
            .subscribe(model => {
                // sync form & params state
                this.formInstance.patchValue(model, {emitEvent: false});
                this.initialValues = model;
            });
    }

    protected createChangeSubscription(): Observable<CollectionSearchParamsModel> {
        return merge(
            this.collection.valueChanges.pipe(
                map((collection: string) => ({
                    collection: collection,
                    pageNumber: 1,
                    filter: this.searchParamsFactoryService.createFilter(collection as ProductCollectionsEnum)
                }))
            ),
            this.sorting.valueChanges.pipe(
                map((sorting: string) => ({
                    sorting: sorting,
                    filter: this.initialValues.filter  // restore the last submitted filter
                }))
            ),
            this.pageNumber.valueChanges.pipe(
                map((pageNumber: string) => ({
                    pageNumber: pageNumber,
                    filter: this.initialValues.filter  // restore the last submitted filter
                }))
            )
        )
        .pipe(
            map(partialModel => this.getModel(partialModel))
        );
    }

    public reset(): void {
        this.pageNumber.setValue(1, {emitEvent: false});
        this.filter.setValue(this.searchParamsFactoryService.createFilter(this.collection.value), {emitEvent: false});
    }
}
